var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.brand == "cb"
      ? _c("img", {
          staticClass: "size-w-40 bg-white border-grey7 p-5 radius-4 mr-5",
          attrs: { title: "CB", src: "dist/assets/payment/cb.svg" },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.brand == "MASTERCARD"
      ? _c("img", {
          staticClass: "size-w-40 bg-white border-grey7 p-5 radius-4 mr-5",
          attrs: {
            title: "MASTERCARD",
            src: "dist/assets/payment/mastercard.svg",
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.brand == "MAESTRO"
      ? _c("img", {
          staticClass: "size-w-40 bg-white border-grey7 p-5 radius-4 mr-5",
          attrs: { title: "MAESTRO", src: "dist/assets/payment/maestro.svg" },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.brand == "VISA"
      ? _c("img", {
          staticClass: "size-w-40 bg-white border-grey7 p-5 radius-4 mr-5",
          attrs: { title: "VISA", src: "dist/assets/payment/visa.svg" },
        })
      : _vm._e(),
    _vm._v(" "),
    !_vm.brand
      ? _c("span", { staticClass: "size-w-40 mr-5", attrs: { title: "" } })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }